import * as AdType from 'common/constants/ad-type';
import * as ResponsiveState from 'show-page/constants/responsive-state';
import * as VideoType from 'common/constants/video-type';
import DisplayAd from 'show-page/components/display-ad';
import Environment from 'common/utils/environment';
import MobileAppPrompt from 'common/components/mobile-app-prompt';
import ShowContent from 'show-page/containers/show-content';
import ShowFooter from 'show-page/containers/show-footer';
import ShowHeader from 'show-page/containers/show-header';
import styles from './styles.less';
import { debounce, get } from 'lodash';
import { findDOMNode } from 'react-dom';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';


@observer(['adManager', 'cvpAuthStore', 'showStore', 'uiStore'])
class ShowPage extends React.Component {
    constructor(props) {
        super(props);
        this.processedRegistry = false;
        this.state = {
            adType: props.adManager.adType,
            responsiveState: props.uiStore.responsiveState,
            selectedVideo: props.showStore.selectedVideo
        };
    }

    componentWillMount() {
        this.pickerCancelledListener = reaction(
            () => this.props.cvpAuthStore.cancelled,
            this.handlePickerCancelled,
            false
        );
        this.responsiveStateListener = reaction(
            () => this.props.uiStore.responsiveState,
            (responsiveState) => this.setState({ responsiveState }),
            true
        );
        this.selectedVideoListener = reaction(
            () => this.props.showStore.selectedVideo,
            this.handleSelectedVideo,
            true
        );
        this.adTypeListener = reaction(
            () => this.props.adManager.adType,
            (adType) => this.setState({ adType }),
            true
        );
    }

    componentDidMount() {
        this.props.uiStore.setMounted(true);
        if (this.state.adType === AdType.DFP) {
            this.processRegistry();
        }
        window.addEventListener('resize', this.handleResize, false);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.video && !this.props.params.video) {
            this.scrollToTop();
        }
        if (this.state.adType !== AdType.DFP) {
            return;
        }
        if (!this.processedRegistry) {
            return this.processRegistry();
        }
        if (prevState.responsiveState !== ResponsiveState.DESKTOP && this.state.responsiveState === ResponsiveState.DESKTOP) {
            this.processRegistry();
        } else if (prevState.selectedVideo && prevState.selectedVideo !== this.state.selectedVideo && (!this.state.selectedVideo || this.state.selectedVideo.type !== VideoType.EPISODE)) {
            this.refreshAllAds();
        } else if (prevState.adType !== AdType.DFP || this.state.responsiveState !== prevState.responsiveState) {
            this.refreshAllAds();
        } else if (prevState.selectedVideo !== this.state.selectedVideo) {
            this.refreshAllAds();
        }
    }

    componentWillUnmount() {
        this.props.uiStore.setMounted(false);
        this.adTypeListener();
        this.adTypeListener = null;
        this.pickerCancelledListener();
        this.pickerCancelledListener = null;
        this.responsiveStateListener();
        this.responsiveStateListener = null;
        this.selectedVideoListener();
        this.selectedVideoListener = null;
        window.removeEventListener('resize', this.handleResize, false);
    }

    render() {
        const { adType } = this.props.adManager;
        const adKey = get(this.props.showStore, 'selectedVideo.id', '');
        return (
            <div className={ styles.root }>
                <div className={ styles.topAdContainer }>
                    <DisplayAd
                        adID='ad_bnr_atf_01'
                        adKey={ adKey }
                        adType={ adType }
                        dfpProps={{ className: styles.topAd, type: 'bnr' }}
                        fwProps={{ className: styles.freewheelAd }}
                    />
                </div>
                <ShowHeader
                    className={ styles.header }
                    params={ this.props.params }
                />
                <ShowContent
                    className={ styles.content }
                    onVideoSelect={ this.handleVideoSelect }
                />
                <ShowFooter
                    className={ styles.footer }
                    onVideoSelect={ this.handleVideoSelect }
                />
                { !!this.props.uiStore.appPromptState &&
                <MobileAppPrompt
                    onClose={ this.handleAppPromptClose }
                    onResponse={ this.handleAppPromptResponse }
                /> }
            </div>
        );
    }

    handleAppPromptClose = () => {
        this.props.uiStore.setAppPromptState(false);
    };

    handleAppPromptResponse = (response) => {
        this.props.uiStore.setAppPromptState(false);
        if (response) {
            this.props.showStoreopenAppLink();
        } else {
            this.props.showStore.gotoLanding();
        }
    };

    handlePickerCancelled = (cancelled) => {
        if (cancelled) {
            this.props.showStore.gotoLanding();
        }
    };

    handleResize = debounce(() => {
        this.props.uiStore.setViewportWidth(window.innerWidth);
    }, 200);

    handleSelectedVideo = (selectedVideo) => {
        const promptState = (selectedVideo && selectedVideo.auth && Environment.mobile);
        this.props.uiStore.setAppPromptState(promptState);
        this.setState({ selectedVideo });
    };

    handleVideoSelect = (video) => {
        if (video.slug !== this.props.params.video) {
            this.scrollToTop();
        }
    };

    processRegistry = () => {
        this.props.adManager.processRegistry();
        this.processedRegistry = true;
    };

    refreshAllAds = () => {
        this.props.adManager.refreshAllAds();
    };

    scrollToTop() {
        const el = findDOMNode(this);
        if (Environment.mobile && 'scrollIntoView' in el) {
            el.scrollIntoView();
        } else {
            TweenLite.to(window, 1, { scrollTo: el });
        }
    }
}


export default ShowPage;



/** WEBPACK FOOTER **
 ** ./src/show-page/containers/main/index.js
 **/